<script>

	import { onMount, afterUpdate, beforeUpdate } from 'svelte';

	import Loader from './components/Loader.svelte';
	import Landing from './components/Landing.svelte';
	import Header from './components/Header.svelte';
	import Page from './components/Page.svelte';

	let active = 0;
	let modalVisible = true;
	let pageVisible = false;
	let conversation = 0;
	let page = 'diversity';
	const vw = window.innerWidth;
	const vh = window.innerHeight;

	function updateActive(i) {active = i; conversation = 0; scroll(0, 0); }
	function updateConversation(i) { conversation = i; }
	function toggleModal() {
		modalVisible = !modalVisible;
		pageVisible = !pageVisible;
	}

	function positionAnnotations() {
		document.querySelectorAll('.comment').forEach( (el, i) => {

			let rect, t, l, r, w, l0;

			w = el.getBoundingClientRect().width;
			l0 = -w/2 + 12;
			el.style.left = l0+'px';

			rect = el.getBoundingClientRect();
			t = rect.top;
			l = rect.left;
			r = rect.right - vw;

			if (l < 0 && r > 0) {el.style.maxWidth = '250px'; el.style.left = (l0-l+20) + 'px'; } // if cutoff both sides
			else if (l < 0) { el.style.left = (l0-l+10) + 'px'; } // If cutoff on left
			else if (r > 0) { el.style.left = (l0-r-10) + 'px'; } // If cutoff on right

		});
	}

	afterUpdate(() => {
		positionAnnotations();
	});

	beforeUpdate(() => {
		if (pageVisible) {
			loader.style.display = 'block';
			loader.style.opacity = 0.1;
			setTimeout(() => {loader.style.opacity = 0;}, 0);
			setTimeout(() => {loader.style.display = "none";}, 500);
		}
	});

	onMount( () => {
		let loader = document.querySelector('#loader');
	});

</script>

<svelte:head>
	<style type="text/css">body { margin: 0; } main { overflow: hidden; } </style>
</svelte:head>

<main>
	<Loader />
	<Landing {modalVisible} {toggleModal} {updateActive}/>
	{#if pageVisible}
		<Header {active} {updateActive} />
		<Page {active} {conversation} {updateConversation} {toggleModal} />
	{/if}
</main>

<style type="text/sass" global>
@import ./styles/app.sass
</style>
